import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import config from "@/middlewares/config"

const augusteRoutes: RouteRecordRaw[] = [
  {
    path: "/auguste/library",
    name: "auguste-library",
    component: () => import("@/views/AugusteLibrary.vue"),
    meta: {
      hideIntercom: true,
      hidePwaInstallBanner: true,
      middleware: [auth, config],
      title: "auguste.library.page_title",
    },
  },
  {
    path: "/auguste/publication-calendar",
    name: "auguste-publication-calendar",
    component: () => import("@/views/AugustePublicationCalendar.vue"),
    meta: {
      hideIntercom: true,
      hidePwaInstallBanner: true,
      middleware: [auth, config],
      title: "auguste.publication_calendar.page_title",
    },
  },
]

export default augusteRoutes
